// Tailwind v4 requires Chrome 111 / Safari 16.4 / Firefox 128. Below that the
// interface renders broken, so main.jsx shows staff an update notice instead
// (guest QR pages are exempt - see boot.js). registerProperty is @property
// (Safari 16.4); color-mix arrived in Chrome 111.
export function canUseNextUi(env = globalThis) {
  const css = env.CSS;
  return Boolean(
    css &&
      typeof css.registerProperty === "function" &&
      typeof css.supports === "function" &&
      css.supports("color", "color-mix(in oklab, red, blue)") &&
      css.supports("color", "oklch(0 0 0)"),
  );
}
